import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subawardId',
      },
    ],
  },
  target: 'ent:!subawards:!subaward',
  quantity: 1,
  selection: {
    '{}': {
      name: 'Info',
      type: 'details',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.save-subaward',
            },
          },
        ],
      },
      content: {
        '{}': {
          sections: {
            '[]': [
              {
                '{}': {
                  name: 'General',
                  fields: {
                    '[]': [
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'code',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!code',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!code',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'name',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!name',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!name',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'descr',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!descr',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!descr',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              direct: {
                                '{}': {
                                  name: 'Project',
                                  type: 'TEXT',
                                },
                              },
                            },
                          },
                          value: 'TODO',
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'budget_period',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!budget_period',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!budget_period',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'curr_amount',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!curr_amount',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!curr_amount',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'perf_period',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!perf_period',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!perf_period',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'total_amount',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!total_amount',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!total_amount',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              direct: {
                                '{}': {
                                  name: 'Key Personnel per NOA',
                                  type: 'TEXT',
                                },
                              },
                            },
                          },
                          value: 'TODO',
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'is_ammend',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!is_ammend',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!is_ammend',
                          },
                          readonly: true,
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Contacts And Addresses',
                  fields: {
                    '[]': [
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              direct: {
                                '{}': {
                                  name: 'PI',
                                  type: 'TEXT',
                                },
                              },
                            },
                          },
                          value: {
                            '@': 'piNames',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              direct: {
                                '{}': {
                                  name: 'Subrecipient PI',
                                  type: 'TEXT',
                                },
                              },
                            },
                          },
                          value: {
                            '@': 'subrecipientPiName',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'admin_contact',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!admin_contact',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!admin_contact',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'fin_contact',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!fin_contact',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!fin_contact',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'invoice_contact',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!invoice_contact',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!invoice_contact',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'authorized_contact',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!authorized_contact',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!authorized_contact',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'perf_address',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!perf_address',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!perf_address',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'admin_address',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!admin_address',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!admin_address',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              id: 'pay_address',
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subawards#!subaward:!pay_address',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!pay_address',
                          },
                          readonly: true,
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-edit atn-blue',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.subawards.widgets.edit-subawards',
                        },
                      },
                      variables: {
                        '{}': {
                          subawardId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        ],
      },
    },
  },
  subqueries: {
    subrecipientPiName: {
      ref: {
        attr: 'attr:ent#!subawards#!subaward:!subrecip_pi',
      },
      target: 'ent:!ext_personnel:!employee',
      selection: {
        '@.': '!name',
      },
    },
    subawardProject: {
      ref: {
        attr: 'attr:ent#!subawards#!subaward:!proj',
      },
      target: 'ent:!projects:!proj',
    },
    projectAward: {
      ref: {
        attr: 'attr:ent#!projects#!proj:!award',
      },
      using: 'subawardProject',
      target: 'ent:!awards:!award',
    },
    awardPis: {
      ref: {
        attr: 'attr:ent#!award_pis#!entry:!award',
      },
      using: 'projectAward',
      target: 'ent:!award_pis:!entry',
    },
    piNames: {
      ref: {
        attr: 'attr:ent#!award_pis#!entry:!pi',
      },
      using: 'awardPis',
      target: 'ent:!personnel:!employee',
      selection: {
        '@.': '!name',
      },
    },
  },
}
